import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  Popper,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import {
  GoogleMap,
  Polygon,
  StreetViewPanorama,
  InfoWindow,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";

export default function Map({
  mapData,
  width,
  height,
  direction,
  sm,
  open,
  popper,
  anchorEl,
  onClose = () => {},
}) {
  const [lng, setLng] = useState();
  const [lat, setLat] = useState();
  const [coordinates, setCoordinates] = useState([]);
  const firstRender = useRef(true);
  const data = mapData ?? JSON.parse(localStorage.getItem("@fullhouseMapData"));

  const { isLoaded } = useLoadScript({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyAmN8gx3xtVVI4kMAvjAruO9yUgPenMPqE",
  });

  const options = {
    fillColor: "#f44336",
    fillOpacity: 0.2,
    strokeColor: "#f44336",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 10,
  };

  const containerStyle = {
    width: width ? width : "100%",
    height: popper ? "300px" : height ? height : "400px",
  };

  const RenderMap = (props) => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={{
          lat: lat,
          lng: lng,
        }}
        zoom={18}
      >
        <Marker
          position={{
            lat: lat,
            lng: lng,
          }}
        >
          <InfoWindow
            position={{
              lat: lat,
              lng: lng,
            }}
          >
            <Grid container direction="column" style={{ overflow: "hidden" }}>
              <Grid item>
                <Typography style={{ color: "red" }}>
                  {data.obj_type === "H"
                    ? data.obj_city + data.obj_area + data.obj_address
                    : data.obj_city +
                      data.obj_area +
                      data.obj_section +
                      "段" +
                      data.obj_section_s +
                      (data.obj_section_s ? "小段" : "") +
                      data.obj_landno +
                      (data.obj_landno ? "地號" : "")}
                </Typography>
              </Grid>
              <Grid item>
                <img
                  style={{ maxHeight: "50px", width: "100%" }}
                  src={require("../../images/mapMark.jpg").default}
                />
              </Grid>
            </Grid>
          </InfoWindow>
        </Marker>
        {coordinates.length !== 0 && (
          <Polygon path={coordinates} options={options} />
        )}
        {props.streetView && (
          <StreetViewPanorama
            position={{
              lat: lat,
              lng: lng,
            }}
            visible={true}
          ></StreetViewPanorama>
        )}
      </GoogleMap>
    );
  };
  useEffect(() => {
    if (data.obj_city && firstRender.current) {
      let latlng = [];
      //TODO 一次請求太多 87操作 之後要改
      fetch(
        `https://twland.ronny.tw/index/search?lands[]=${
          data.obj_city + "," + data.obj_section + "段" + "," + data.obj_landno
        }`
      )
        .then((res) => res.json())
        .then((result) => {
          result.features[0].geometry.coordinates[0].forEach((item) =>
            item.forEach((item2) =>
              latlng.push({ lat: item2[1], lng: item2[0] })
            )
          );
          setLat(result.features[0].properties.ycenter);
          setLng(result.features[0].properties.xcenter);
          setCoordinates(latlng);
        })
        .catch((e) => {
          fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${
              data.obj_type === "H"
                ? data.obj_city + data.obj_area + data.obj_address
                : data.obj_city +
                  data.obj_area +
                  data.obj_section +
                  "段" +
                  data.obj_section_s +
                  (data.obj_section_s ? "小段" : "") +
                  data.obj_landno +
                  (data.obj_landno ? "號" : "")
            }&key=AIzaSyAmN8gx3xtVVI4kMAvjAruO9yUgPenMPqE`
          )
            .then((res) => res.json())
            .then(({ results, status }) => {
              if (status === "OK") {
                setLng(results[0].geometry.location.lng);
                setLat(results[0].geometry.location.lat);
              }
            });
        });
      if (!popper) firstRender.current = false;
    }
  }, [data]);
  if (isLoaded && !!lng && !!lat) {
    if (popper) {
      return (
        <Popper
          id="mouse-over-mapPopover"
          open={open}
          anchorEl={anchorEl}
          placement="buttom"
          disablePortal={false}
          style={{ minHeight: 500, minWidth: 700, zIndex: 1000 }}
          onMouseLeave={onClose}
          modifiers={{
            flip: {
              enabled: true,
            },
            preventOverflow: {
              enabled: true,
              rootBoundary: "document",
              boundariesElement: "scrollParent",
            },
          }}
        >
          <Grid container spacing={1}>
            <Grid item sm={6}>
              <RenderMap />
            </Grid>
            <Grid item sm={6}>
              <RenderMap streetView />
            </Grid>
          </Grid>
        </Popper>
      );
    } else {
      return (
        <Grid container spacing={1} direction={direction ?? "column"}>
          <Grid item sm={sm ?? 12}>
            <RenderMap />
          </Grid>
          <Grid item sm={sm ?? 12}>
            <RenderMap streetView />
          </Grid>
        </Grid>
      );
    }
  } else {
    return null;
  }
}
